import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import { StyledInput, StyledLabel, StyledMessaging, StyledSelect, StyledTextArea, StyledErrorMessage } from './VirtualGiftCardProductFormStyles';

var _ref = React.createElement(
  StyledLabel,
  null,
  'Delivery'
);

var _ref2 = React.createElement(
  'option',
  { value: 'recipient' },
  'Email to Recipient'
);

var _ref3 = React.createElement(
  'option',
  { value: 'myself' },
  'Email to Myself'
);

var _ref4 = React.createElement(
  StyledMessaging,
  null,
  'Please do not use emojis in any of the below fields'
);

var _ref5 = React.createElement(
  StyledErrorMessage,
  null,
  'Please enter a valid name.'
);

var _ref6 = React.createElement(
  StyledErrorMessage,
  null,
  'Invalid email address'
);

var _ref7 = React.createElement(
  StyledErrorMessage,
  null,
  'Please enter a valid name.'
);

var _ref8 = React.createElement(
  StyledErrorMessage,
  null,
  'Invalid email address'
);

var VirtualGiftCardProductForm = function VirtualGiftCardProductForm(props) {
  var revertErrorState = function revertErrorState(name) {
    if (props.handleVirtualGiftCardError) props.handleVirtualGiftCardError(name, false);
  };

  return React.createElement(
    'div',
    null,
    _ref,
    React.createElement(
      StyledSelect,
      {
        value: props.virtualGiftCardSelectOption,
        onChange: function onChange(e) {
          return props.setVirtualGiftCardSelectOption(e.target.value);
        },
        onBlur: function onBlur(e) {
          return props.setVirtualGiftCardSelectOption(e.target.value);
        }
      },
      _ref2,
      _ref3
    ),
    _ref4,
    props.virtualGiftCardSelectOption !== 'myself' ? React.createElement(
      Fragment,
      null,
      React.createElement(StyledInput, {
        type: 'text',
        name: 'rName',
        placeholder: 'Recipient Name',
        value: props.virtualGiftCardValues['rName'],
        onChange: props.handleMonogramInput,
        onFocus: function onFocus() {
          return revertErrorState('rName');
        },
        error: props.virtualGiftCardError['rName']
      }),
      props.virtualGiftCardError['rName'] && _ref5,
      React.createElement(StyledInput, {
        type: 'text',
        name: 'rEmail',
        placeholder: 'Recipient Email',
        value: props.virtualGiftCardValues['rEmail'],
        onChange: props.handleMonogramInput,
        onFocus: function onFocus() {
          return revertErrorState('rEmail');
        },
        error: props.virtualGiftCardError['rEmail']
      }),
      props.virtualGiftCardError['rEmail'] && _ref6
    ) : null,
    React.createElement(StyledInput, {
      type: 'text',
      name: 'sName',
      placeholder: 'Your Name',
      value: props.virtualGiftCardValues['sName'],
      onChange: props.handleMonogramInput,
      onFocus: function onFocus() {
        return revertErrorState('sName');
      },
      error: props.virtualGiftCardError['sName']
    }),
    props.virtualGiftCardError['sName'] && _ref7,
    React.createElement(StyledInput, {
      type: 'text',
      name: 'sEmail',
      placeholder: 'Your Email',
      value: props.virtualGiftCardValues['sEmail'],
      onChange: props.handleMonogramInput,
      onFocus: function onFocus() {
        return revertErrorState('sEmail');
      },
      error: props.virtualGiftCardError['sEmail']
    }),
    props.virtualGiftCardError['sEmail'] && _ref8,
    React.createElement(StyledTextArea, {
      type: 'text',
      name: 'message',
      placeholder: 'Message',
      value: props.virtualGiftCardValues['message'],
      onChange: props.handleMonogramInput,
      maxlength: 1000
    })
  );
};

VirtualGiftCardProductForm.propTypes = {
  tags: PropTypes.array.isRequired,
  monogramInputValue: PropTypes.string,
  handleMonogramInput: PropTypes.func,
  virtualGiftCardError: PropTypes.object.isRequired,
  handleVirtualGiftCardError: PropTypes.func.isRequired,
  virtualGiftCardValues: PropTypes.object.isRequired,
  virtualGiftCardSelectOption: PropTypes.string.isRequired,
  setVirtualGiftCardSelectOption: PropTypes.func.isRequired
};

export default React.memo(VirtualGiftCardProductForm);